export interface PlaceDetails {
  name: string;
  formatted_address: string;
  geometry: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
  address_components?: google.maps.GeocoderAddressComponent[];
}

export const getPlaceDetails = (
  placeId: string,
  fields: string[] = ['name', 'formatted_address', 'geometry']
): Promise<PlaceDetails | string> => {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps) {
      reject(new Error('Google Maps is not loaded'));
      return;
    }

    const service = new google.maps.places.PlacesService(document.createElement('div'));

    const request: google.maps.places.PlaceDetailsRequest = {
      placeId,
      fields
    };

    service.getDetails(request, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && place) {
        resolve(place as PlaceDetails);
      } else {
        reject(new Error(`Error fetching place details: ${status}`));
      }
    });
  });
};
